module.exports = __webpack_public_path__ + "img/selectIcon.1b53f018.png";